angular.module('impactx.search').controller('ListTabContainerCtrl', [
    '$element',
    '$timeout',
    'SearchFilter',
    '$route',
    'SearchService',
    '$securityManager',
    'TranslationService',
    'AppConfiguration',
    '$scope',
    'SearchFilterStorage',
    '$routeParams',
    '$location',
    ListTabContainerController
]);

function ListTabContainerController($element, $timeout, SearchFilter, $route, SearchService, $securityManager,
                                    TranslationService, AppConfiguration, $scope, SearchFilterStorage, $routeParams, $location) {
    var self = this;
    var containerElement, searchViewElement, inkBar;
    self.requestInProgress = false;
    self.panes = [];
    self.pageNumber = 1;
    self.shouldScroll = false;

    self.$onInit = function () {
        self.pageNumber = self.productPageNumberFilter && self.productPageNumberFilter.productPageNumber ?
            self.productPageNumberFilter.productPageNumber : self.pageNumber;

        containerElement = $element;
        angular.element(function () {
            searchViewElement = angular.element('#search-view');
            registerScrollTop();
        });
        self.rowButtons = $securityManager.isSuperUser() ? [10, 20, 50, 100, 200] : [10, 20, 50];
        if (self.rowButtons.indexOf(AppConfiguration.get('numberOfProductsInSearch')) < 0) {
            self.rowButtons.push(AppConfiguration.get('numberOfProductsInSearch'));
            self.rowButtons.sort(function(a, b) {
                return a - b;
            });
        }

        self.searchService = SearchService;
        self.rowButtonsLabel = TranslationService.get("productRowButtons");
    };

    self.addPane = function (pane) {
        if (self.panes.length === 0) {
            self.selectTab(pane);
        }
        self.panes.push(pane);
    };

    self.selectTab = function (pane) {
        self.pageNumber = self.pageNumber > 1 ? self.pageNumber : 1;
        angular.forEach(self.panes, function (paneEntry) {
            paneEntry.selected = false;
        });
        pane.selected = true;
        self.updateInkBar();
        self.showLists = true;
    };

    self.previousPage = function (shouldScrollTop) {
        if (self.pageNumber > 0)
        {
            self.pageNumber--;
            if (self.productPageNumberFilter)
            {
                //update will be done in watcher
                self.productPageNumberFilter.productPageNumber = self.pageNumber;
                self.shouldScroll = shouldScrollTop;
            }
            else
            {
                self.updateContent(null, null, shouldScrollTop);
            }
        }
    };

    self.selectNumberOfProductRows = function (numberOfProductRows) {
        SearchService.setNumberOfProductRows(numberOfProductRows);

        if (!$routeParams.useSetFilter) {
            if ($location.path().indexOf("/vcatalog/") > -1 ||
                $location.path().indexOf("/tender/") > -1 ||
                $location.path().indexOf("/lot/") > -1 ||
                $location.path().indexOf("/supplier/") > -1 ||
                $location.path().indexOf("/manufacturer/") > -1) {
                    SearchFilter.getFilters().searchInputUsed = true;
            }
        }
        $route.reload();
    };

    self.nextPage = function (shouldScrollTop) {
        self.pageNumber++;
        if (self.productPageNumberFilter) {
            //update will be done in watcher
            self.productPageNumberFilter.productPageNumber = self.pageNumber;
            self.shouldScroll = shouldScrollTop;

        }
        else {
            self.updateContent(null, null, shouldScrollTop);
        }
    };

    self.hasPreviousPage = function () {
        return self.pageNumber > 1;
    };

    self.hasNextPage = function () {
        return self.pageNumber < self.maxPageNumber;
    };

    self.toggleLists = function () {
        self.showLists = !self.showLists;
    };

    self.setInkBar = function (inkBarElement) {
        inkBar = inkBarElement;
    };

    self.updateInkBar = function () {
        $timeout(function () {
            var selectedElement = containerElement.find('.selected');
            if (selectedElement.length > 0) {
                var width = selectedElement.width() - 32;
                var offset = selectedElement.position().left + 16;

                if (inkBar) {
                    inkBar.style.width = width + 'px';
                    inkBar.style.left = offset + 'px';
                }
            }
        }, 100);
    };

    self.updateContent = function (pageNumber, selectedSort, shouldScrollTop) {
        if (!pageNumber) {
            pageNumber = self.pageNumber;
        }
        else {
            self.pageNumber = pageNumber;
        }
        self.requestInProgress = true;
        self.updatePageFunction({index: pageNumber, selectedSort: selectedSort}).then(function () {
            self.requestInProgress = false;
            if(shouldScrollTop) {
                scrollToTop();
            }
        });
    };

    function scrollToTop() {
        var topOffset = containerElement.offset().top + searchViewElement.scrollTop();
        searchViewElement.animate({
            scrollTop: topOffset - searchViewElement.offset().top
        }, 200);
    }

    function registerScrollTop() {
        searchViewElement.bind('scroll', scrollTop);
    }

    function scrollTop() {
        var viewHeight = angular.element('#ix-main-view').height();
        var topOffset = containerElement.offset().top + searchViewElement.scrollTop();
        var searchViewTop = searchViewElement.offset().top;
        self.showScrollTopButton = containerElement.offset().top < searchViewTop - viewHeight;

        self.showScrollTop({showScrollTop: self.showScrollTopButton, scrollPosition: topOffset - searchViewTop})
    }

    $scope.$watch(function () {
        return self.productPageNumberFilter ? self.productPageNumberFilter.productPageNumber : 0;
    }, function (newVal, oldVal) {
        if (newVal !== oldVal && newVal > 0) {
            self.pageNumber = newVal;
            self.updateContent(null, null, self.shouldScroll);
        }
    });

    $scope.$watch(function () {
        return self.resetPageNumber && self.resetPageNumber.value;
    }, function (newVal, oldVal) {
        if (newVal) {
            self.pageNumber = 1;
            self.resetPageNumber.value = false;
        }
    });
}
